import { render, staticRenderFns } from "./GroupOfAccreditationItemRequests.vue?vue&type=template&id=43dbed5a&scoped=true"
import script from "./GroupOfAccreditationItemRequests.vue?vue&type=script&lang=js"
export * from "./GroupOfAccreditationItemRequests.vue?vue&type=script&lang=js"
import style0 from "./GroupOfAccreditationItemRequests.vue?vue&type=style&index=0&id=43dbed5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dbed5a",
  null
  
)

export default component.exports